<template>
  <q-table
    flat
    :dense="$q.screen.x"
    :class="
      this.$q.dark.mode === true
        ? 'table-sticky-header-column-dark'
        : tablethreadColor()
    "
    bordered
    :rows="finalRowData"
    :columns="
      isMarketOn && marketLive
        ? columnsMarketLive
        : tabPeriod == 'daily'
        ? columnsMarketDaily
        : tabPeriod == 'weekly'
        ? columnsMarketWeekly
        : tabPeriod == 'monthly'
        ? columnsMarketMonthly
        : []
    "
    binary-state-sort
    separator="cell"
    :pagination="pagination"
    @row-click="onClickSectorRow"
  >
    <template v-slot:body-cell="props">
      <q-td
        style="padding: 4px"
        :props="props"
        :class="
          this.$q.dark.mode === true
            ? props.row.symbol == selectedIndexSymbol
              ? 'bg-grey-9'
              : ''
            : props.row.symbol == selectedIndexSymbol
            ? ''
            : ''
        "
      >
        <div class="row">
          <div class="col">
            {{ props.value }}
          </div>

          <!-- <div
            style="font-size: 12px; margin-left: -30px"
            v-if="
              (props.row.point_change ||
                props.row.point_change_weekly ||
                props.row.point_change_monthly) &&
              (props.col.name == 'point_change' ||
                props.col.name == 'point_change_weekly' ||
                props.col.name == 'point_change_monthly')
            "
            class="col q-mt-md"
          >
            {{
              tabPeriod == "daily"
                ? props.row.percentage_change.toFixed(2)
                : tabPeriod == "weekly"
                ? props.row.percentage_change_weekly.toFixed(2)
                : tabPeriod == "monthly"
                ? props.row.percentage_change_monthly.toFixed(2)
                : ""
            }}%
          </div> -->
        </div>
      </q-td>
    </template>
  </q-table>
</template>

<script>
import { ref, watchEffect, computed, onMounted } from "vue";

import useData from "src/use/data";
import useCore from "src/use/core";
import useUtils from "src/use/utils";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

export default {
  name: "MarketSummary",
  props: {
    theme: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMarketOn: {
      type: Boolean,
      required: false,
      default: false,
    },
    marketLive: {
      type: Array,
    },
    marketDaily: { type: Array },
    marketWeekly: { type: Array },
    marketMonthly: { type: Array },
    tabPeriod: {
      type: String,
      required: false,
      default: "daily",
    },
  },
  emits: ["clickSectorRow", "emitSector"],

  setup(props, context) {
    const { indexPerformance, intraIndexPerformance } = useData();
    const { allIndex, allSector } = useCore();
    const { allIndexs, chooseTabColor } = useUtils();
    const $q = useQuasar();
    const store = useStore();

    const indices = ref([]);
    const skipIndices = ref(["SENSFLTIND", "SENSIND", "FLOATIND"]);
    const sectors = ref([]);
    const emitSector = ref({});
    const rowData = ref([]);

    const selectedIndexSymbol = ref("NEPSE");

    const pagination = ref({
      rowsPerPage: 14,
      sortBy: "turnover",
      descending: true,
    });

    rowData.value =
      props.isMarketOn && props.marketLive
        ? props.marketLive
        : props.tabPeriod == "daily" && props.marketDaily
        ? props.marketDaily
        : props.tabPeriod == "weekly" && props.marketWeekly
        ? props.marketWeekly
        : props.tabPeriod == "monthly" && props.marketMonthly
        ? props.marketMonthly
        : [];

    const finalRowData = computed(() => {
      const { tabPeriod } = props;
      let amount;

      switch (tabPeriod) {
        case "monthly":
          amount = rowData.value.find(
            (i) => i.symbol === "NEPSE"
          )?.amount_monthly;
          break;
        case "weekly":
          amount = rowData.value.find(
            (i) => i.symbol === "NEPSE"
          )?.amount_weekly;
          break;
        default:
          amount = rowData.value.find((i) => i.symbol === "NEPSE")?.amount;
      }

      return rowData.value.map((item) => ({
        ...item,
        amt: amount,
      }));
    });

    const columnsMarketLive = [
      {
        name: "name",
        label: "Name",
        field: "name",
        sortable: true,
        align: "left",
        style: "padding:4px;max-width:10px;min-width:80px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
      },
      // {
      //   name: "previous_close",
      //   label: "Prev LTP",
      //   field: "prev_close",
      //   sortable: true,
      //   align: "center",
      // },
      {
        name: "point_change",
        label: "P.CH",
        field: "point_change",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return `${parseFloat(val).toFixed(2)} `;
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0 ? "color:green" : "color:red";
        },
      },
      {
        name: "percentage_change",
        label: "CH% ",
        field: "percentage_change",
        sortable: true,
        align: "center",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green; "
            : "color:red; ";
        },
      },
      {
        name: "turnover",
        label: "Amt (Cr.)",
        field: "amount",
        align: "center",
        style: "max-width:10px;mix-width:10px;",
        sortable: true,
        format: (val, row) => {
          return (
            parseFloat(val / 10000000).toFixed(2) +
            " (" +
            ((row.amount / row.amt) * 100).toFixed(2) +
            " %)"
          );
        },
      },
    ];
    const columnsMarketDaily = [
      {
        name: "name",
        label: "Name",
        field: "name",
        align: "left",
        style: "max-width:60px;min-width:60px;padding:4px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
      },
      // {
      //   name: "prev_close",
      //   label: "Prev LTP",
      //   field: "prev_close",
      //   align: "center",
      //   sortable: true,
      // },
      {
        name: "point_change",
        label: "P.CH",
        field: "point_change",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return `${parseFloat(val).toFixed(2)} `;
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0 ? "color:green" : "color:red";
        },
      },
      {
        name: "percentage_change",
        label: "CH%",
        field: "percentage_change",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "turnover",
        label: "Amt (Cr.)",
        field: "amount",
        align: "center",
        sortable: true,
        style: "max-width: 10px",

        format: (val, row) => {
          return (
            parseFloat(val / 10000000).toFixed(2) +
            " (" +
            ((row.amount / row.amt) * 100).toFixed(2) +
            " %)"
          );
        },
      },
      {
        name: "amount_change_daily",
        label: "Amt.CH %",
        field: "amount_change_daily",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_daily) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];
    const columnsMarketWeekly = [
      {
        name: "name",
        label: "Name",
        field: "name",
        align: "left",
        style: "max-width:60px;min-width:60px;padding:4px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
      },
      // {
      //   name: "prev_close_weekly",
      //   label: "Prev LTP",
      //   field: "prev_close_weekly",
      //   align: "center",
      //   sortable: true,
      // },
      {
        name: "point_change_weekly",
        label: "P.CH",
        field: "point_change_weekly",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change_weekly) > 0
            ? "color:green"
            : "color:red";
        },
      },

      {
        name: "percentage_change_weekly",
        label: "CH% ",
        field: "percentage_change_weekly",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change_weekly) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "turnover",
        label: "Amt (Cr.)",
        field: "amount_weekly",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return (
            parseFloat(val / 10000000).toFixed(2) +
            " (" +
            ((row.amount_weekly / row.amt) * 100).toFixed(2) +
            " %)"
          );
        },
      },
      {
        name: "amount_change_weekly",
        label: "Amt.CH %",
        field: "amount_change_weekly",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_weekly) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];
    const columnsMarketMonthly = [
      {
        name: "name",
        label: "Name",
        field: "name",
        align: "left",
        style: "max-width:60px;min-width:60px;padding:4px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
      },
      // {
      //   name: "prev_close_monthly",
      //   label: "Prev LTP",
      //   field: "prev_close_monthly",
      //   align: "center",
      //   sortable: true,
      // },
      {
        name: "point_change_monthly",
        label: "P.CH",
        field: "point_change_monthly",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change_monthly) > 0
            ? "color:green"
            : "color:red";
        },
      },

      {
        name: "percentage_change_monthly",
        label: "CH% ",
        field: "percentage_change_monthly",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change_monthly) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "turnover",
        label: "Amt (Cr.)",
        field: "amount_monthly",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return (
            parseFloat(val / 10000000).toFixed(2) +
            " (" +
            ((row.amount_monthly / row.amt) * 100).toFixed(2) +
            " %)"
          );
        },
      },

      {
        name: "amount_change_monthly",
        label: "Amt.CH %",
        field: "amount_change_monthly",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_monthly) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];

    // allIndex().then((res) => {
    //  allIndexs = res.data;
    //   if (props.isMarketOn) {
    //     intraIndexPerformance().then((res) => {
    //       marketLive.value = res.data
    //         .filter((i) => !skipIndices.value.includes(i.symbol))
    //         .map((item) => {
    //           return {
    //             symbol: item.symbol,
    //             name:allIndexs().find((i) => {
    //               return i.symbol === item.symbol;
    //             }).name,
    //             close: item.close ?? 0,
    //             prev_close: item.prev_close ?? 0,
    //             point_change: item.point_change ?? 0,
    //             percentage_change: item.percentage_change ?? 0,
    //             amount: item.amount ?? 0,
    //           };
    //         });
    //     });
    //   } else {
    //     indexPerformance().then((res) => {
    //       marketDaily.value = res.data
    //         .filter((i) => !skipIndices.value.includes(i.symbol))
    //         .map((item) => {
    //           return {
    //             symbol: item.symbol,

    //             name:allIndexs().find((i) => {
    //               return i.symbol === item.symbol;
    //             }).name,
    //             close: item.close ?? 0,
    //             prev_close: item.prev_close ?? 0,
    //             point_change: item.point_change ?? 0,
    //             percentage_change: item.percentage_change ?? 0,
    //             amount: item.amount ?? 0,
    //           };
    //         })
    //         .sort((a, b) => b.amount - a.amount);

    //       marketWeekly.value = res.data
    //         .map((item) => {
    //           return {
    //             symbol: item.symbol,

    //             name:allIndexs().find((i) => {
    //               return i.symbol === item.symbol;
    //             }).name,
    //             close: item.close ?? 0,
    //             prev_close_weekly: item.prev_close_weekly ?? 0,
    //             point_change_weekly: item.point_change_weekly ?? 0,
    //             percentage_change_weekly: item.percentage_change_weekly ?? 0,
    //             amount_weekly: item.amount_weekly ?? 0,
    //           };
    //         })
    //         .sort((a, b) => b.amount_weekly - a.amount_weekly);

    //       marketMonthly.value = res.data
    //         .map((item) => {
    //           return {
    //             symbol: item.symbol,

    //             name:allIndexs().find((i) => {
    //               return i.symbol === item.symbol;
    //             }).name,
    //             close: item.close ?? 0,
    //             prev_close_monthly: item.prev_close_monthly ?? 0,
    //             point_change_monthly: item.point_change_monthly ?? 0,
    //             percentage_change_monthly: item.percentage_change_monthly ?? 0,
    //             amount_monthly: item.amount_monthly ?? 0,
    //           };
    //         })
    //         .sort((a, b) => b.amount_monthly - a.amount_monthly);
    //     });
    //   }
    // });

    allSector().then((res) => {
      sectors.value = res.data;
    });

    function tablethreadColor() {
      return chooseTabColor($q.dark.mode, store.state.domain.domain);
    }

    function onClickSectorRow(evt, row) {
      emitSector.value = row;
      selectedIndexSymbol.value = row.symbol;
      if (row.symbol == "NEPSE") {
        context.emit("clickSectorRow", null);
        return;
      }

      var indexId = allIndexs().find((item) => {
        return item.name == row.name;
      }).id;

      var sectorId = sectors.value.find((item) => item.index == indexId).id;
      var sectorSymbol = allIndexs().find((item) => item.id == indexId).symbol;

      context.emit("clickSectorRow", { sectorSymbol, sectorId });
    }

    watchEffect(() => {
      context.emit("emitSector", emitSector.value);
    });

    onMounted(() => {
      const emitData = finalRowData.value.find((i) => i.symbol === "NEPSE");
      if (emitData) {
        context.emit("emitSector", emitData);
      }
    });

    return {
      finalRowData,

      columnsMarketLive,
      tablethreadColor,

      columnsMarketDaily,
      columnsMarketWeekly,

      columnsMarketMonthly,
      pagination,

      onClickSectorRow,

      selectedIndexSymbol,
    };
  },
};
</script>
